'use client'

import { useDialogStore } from '@/components/dialog/FullScreenBackDrop'
import { AxiosError } from 'axios'

export const useMutation = () => {
  const dialog = useDialogStore()

  return async (fn?: Promise<any>) => {
    try {
      const res = await fn
      return res
    } catch (e) {
      if (e instanceof AxiosError) {
        // dialog.alert({
        //   title: `[${e.response?.data.statusCode}] ${e.response?.data.message} ${e.response?.data.error}`,
        // })
        dialog.alert({
          title: `${e.response?.data.message}`,
        })
        throw e
      }
    }
  }
}
